export default "__VITE_ASSET__ITOhW93G__"